var React = require('react');

function AiAdminSend (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M112 244l144-144 144 144M256 120v292"}));
}

AiAdminSend.defaultProps = {"width":"18","height":"18","viewBox":"0 0 512 512","fill":"none"};

module.exports = AiAdminSend;

AiAdminSend.default = AiAdminSend;
